var map = {
	"./de/authentication/translations.json": 5402,
	"./de/care_plus_onboarding/translations.json": 700,
	"./de/choose_doctor/translations.json": 313,
	"./de/choose_plan_care_plus/translations.json": 7225,
	"./de/choose_treatment/translations.json": 909,
	"./de/choose_treatment_care_plus/translations.json": 9657,
	"./de/contact/translations.json": 8457,
	"./de/customer_verification/translations.json": 3633,
	"./de/default/translations.json": 5873,
	"./de/layout/translations.json": 862,
	"./de/my_account/translations.json": 9929,
	"./de/payment/translations.json": 4891,
	"./de/reorder/translations.json": 6581,
	"./de/repay/translations.json": 9687,
	"./de/shipping/translations.json": 6059,
	"./de/start_consultation/translations.json": 9876,
	"./de/thankyou/translations.json": 9992,
	"./de/wire/translations.json": 5107,
	"./en/authentication/translations.json": 7451,
	"./en/care_plus_onboarding/translations.json": 2278,
	"./en/choose_doctor/translations.json": 5804,
	"./en/choose_plan_care_plus/translations.json": 944,
	"./en/choose_treatment/translations.json": 2900,
	"./en/choose_treatment_care_plus/translations.json": 3208,
	"./en/contact/translations.json": 4597,
	"./en/customer_verification/translations.json": 2845,
	"./en/default/translations.json": 5168,
	"./en/layout/translations.json": 6874,
	"./en/my_account/translations.json": 7940,
	"./en/payment/translations.json": 3402,
	"./en/reorder/translations.json": 5256,
	"./en/repay/translations.json": 415,
	"./en/shipping/translations.json": 9689,
	"./en/start_consultation/translations.json": 12,
	"./en/thankyou/translations.json": 1678,
	"./en/wire/translations.json": 5386,
	"./fr/authentication/translations.json": 5160,
	"./fr/choose_doctor/translations.json": 2917,
	"./fr/choose_treatment/translations.json": 5295,
	"./fr/contact/translations.json": 286,
	"./fr/customer_verification/translations.json": 2629,
	"./fr/default/translations.json": 9010,
	"./fr/layout/translations.json": 4505,
	"./fr/my_account/translations.json": 9028,
	"./fr/payment/translations.json": 2051,
	"./fr/reorder/translations.json": 1729,
	"./fr/repay/translations.json": 714,
	"./fr/shipping/translations.json": 2258,
	"./fr/start_consultation/translations.json": 9893,
	"./fr/thankyou/translations.json": 1728,
	"./fr/wire/translations.json": 8380
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7497;